import { render, staticRenderFns } from "./ReasonsManager.vue?vue&type=template&id=66c0aab4&"
import script from "./ReasonsManager.vue?vue&type=script&lang=ts&"
export * from "./ReasonsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports